import { useQuery } from '@tanstack/react-query';
import { fetchUploadHistory } from '../api/uploads';
import { uploadsKeys } from '../queryKeys';

const FIVE_MINUTES = 5 * 60 * 1000;

const useUploadHistory = (userId) =>
  useQuery({
    queryKey: uploadsKeys.history(userId),
    queryFn: () => fetchUploadHistory(userId),
    enabled: Boolean(userId),
    staleTime: FIVE_MINUTES,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });

export default useUploadHistory;
